
export function getAgentUrl() {
    const urlParams = new URLSearchParams(document.location.search.substring(1));
    const url = urlParams.get("agentUrl");
    return url != null ? atob(url) : "http://localhost:45455";
}

export async function apiPost(fn : string, params? : any) : Promise<any> {
    return fetch(getAgentUrl() + '/api/' + fn, {
        method: "POST",
        body: params ? JSON.stringify(params) : null,
    }).then(res => res.json()).then(response => {
        if (response.error)
            throw new Error(response.error_message);

        return response;
    });
}

export async function apiGet<T=any>(fn : string, params? : any) : Promise<T> {
    let p = '';
    if (params) {
        p = '?' + Object.keys(params).map(key => key + "=" + params[key]).join("&");
    }

    return fetch(getAgentUrl() + '/api/' + fn + p).then(res => res.json()).then(response => {
        if (response.error)
            throw new Error(response.error_message);

        return response;
    });
}

let _spaces : any[] = [];
let spacesLoaded : boolean = false;
export const SpaceService = {
    getSpaces: async () : Promise<any[]> => {
        if (spacesLoaded) {
            return Promise.resolve(_spaces);
        } else {
            return apiGet('getSpaces').then(data => {
                spacesLoaded = true;
                _spaces = data;
                return _spaces;
            });
        }
    },

    getSpace: async (spaceId : number) : Promise<any> => {
        return SpaceService.getSpaces().then(spaces => {
            const match = spaces.filter(s => s.id === spaceId);
            return match.length === 0 ? Promise.reject("Space not found") : match[0];
        });
    }
};

export async function downloadAndOpenFile(_file : {globalId:string}) : Promise<void> {
    return apiGet('getFile', {id: _file.globalId}).then(file => {
        if (!file.isOfflineAvailable) {
            return apiPost('restoreLocallyFile', {id: file.id}).then(() => {
                return downloadAndOpenFile(file);
            });
        } else if (!file.isInFileSystem) {
            return new Promise((resolve/*, reject*/) => {
                setTimeout(resolve, 5000);
            }).then(() => {
                return downloadAndOpenFile(file);
            });
        } else {
            return apiPost('openLocalFile', {
                "fileId": file.id,
                "spaceId": file.spaceId,
            });
        }
    });
}

/**
 * Convert an amount of storage space in bytes to a string like 1GB 2MB 200bytes
 *
 * @param number bytes
 * @param number precision (Optional) How many "positions" to display (eg. for $bytes > 1 GB, precision 1 would omit any MB, KB, or byte values)
 * @return string
 */
export function bytesToStr(bytes : number, precision = 1) : string {
    const unit_labels = ["bytes", "KB", "MB", "GB", "TB"];
    const result : string[] = [];

    unit_labels.forEach(l => {
        if (bytes % 1024 !== 0) {
            result.push(`${bytes % 1024} ${l}`);
        }
        bytes = Math.floor(bytes / 1024);
    });

    return result.length === 0 ? "0 bytes" : result.reverse().slice(0, precision).join(" ");
}

export function getMessage(error_obj : any) : string {
    if (typeof error_obj === 'string') 
        return error_obj;
    
    let message = null;

    ['error','errorMsg','message','errorMessage'].forEach(function(p) {
        if (typeof error_obj[p] !== 'undefined')
            message = error_obj[p];
    });

    if (message != null)
        return message;

    if (typeof error_obj['Error'] !== 'undefined' && typeof error_obj['Error']['Message'] !== 'undefined')
        return error_obj.Error.Message;

    return  JSON.stringify(error_obj);
}